import { render, staticRenderFns } from "./ProcessSignLoading.vue?vue&type=template&id=99c6fd90&scoped=true"
import script from "./ProcessSignLoading.vue?vue&type=script&lang=ts"
export * from "./ProcessSignLoading.vue?vue&type=script&lang=ts"
import style0 from "./ProcessSignLoading.vue?vue&type=style&index=0&id=99c6fd90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c6fd90",
  null
  
)

export default component.exports